module.exports = __webpack_public_path__ + "img/dbcpfw_10.19871518.jpg";